import { z } from "zod";

export const getPartnerCreateBalanceSchema = () => {
	return z.object({
		amount: z.number(),
		description: z.string().nullish(),
		orderId: z.number().int().nullish(),
	});
};

export type PartnerCreateBalanceFormModel = z.infer<
	ReturnType<typeof getPartnerCreateBalanceSchema>
>;
